import { AxiosResponse } from "axios";
import { KeyValue } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";
import { UserGroupFilterRequest } from "@/main/models/request/usergroupRequest";

export abstract class IUserGroupApi {
	abstract getDomain(groupFilter: UserGroupFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
